'use client'

import { Card, CardContent, CardHeader, Stack } from '@mui/material'
import PalleteColorsShowcase from 'common/demo/components/_palleteColors'
import { useState } from 'react'

export default function ColorsShowcase() {
    const [size, setSize] = useState<"small" | "medium">("small")
    return (
        <Card>
            <CardHeader title='Colors Showcase' />
            <CardContent>
                <Stack spacing={2}>
                    <PalleteColorsShowcase />
                </Stack>
            </CardContent>
        </Card>
    )
}
